"use client"

import { usePathname } from "next/navigation"
import BottomNav from "./BottomNav"

const NO_NAV_PATHS = ["/student/login", "/student/adopt"]

export default function ConditionalNav() {
  const pathname = usePathname()
  if (NO_NAV_PATHS.some((p) => pathname.startsWith(p))) return null
  return <BottomNav />
}
